/**
 * Created by Alican Köker
 * on 2018/02/19.
 */
import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {CommonWinAnimationView} from "./CommonWinAnimationView";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";

export class CommonWinPresentationController extends BaseController {

    private _commonWinAnimView: CommonWinAnimationView;
    private _gameData: ParsedGameData;

    constructor() {
        super();
        this._commonWinAnimView = new CommonWinAnimationView();
        this.addEventListeners();
    }

    private addEventListeners(): void {
        EventHandler.addEventListener(this, WinPresentationEvent.WIN_PRESENTATIONS_STARTED, (event: GameEvent) => this.playCommonAnimation());
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    private playCommonAnimation(): void {
        if(this._gameData.singleWin > 0)
            this._commonWinAnimView.startWinSteamAnimations();
    }

    private onGameDataParsed(data: ParsedGameData): void {
        this._gameData = data;
    }
}